import { Box, Stack, Typography } from '@mui/material';
import { ClientPortalTaskComment } from '../../types';
import CommentInlineForm from './CommentInlineForm';
import CommentCard from './CommentCard';
import { CommentActions } from './types';

type CommentsListProps = {
  comments: ClientPortalTaskComment[];
  actions: CommentActions;
  isReadonly?: boolean;
};

const CommentsList = ({ comments, actions, isReadonly = false }: CommentsListProps) => {
  const createForm = actions.activeForm?.type === 'create' ? actions.activeForm : null;

  return (
    <Stack spacing={2} sx={{ p: 2 }}>
      {createForm && (
        <CommentInlineForm
          value={createForm.text}
          submitLabel="Add comment"
          onChange={actions.updateActiveFormText}
          onSubmit={actions.submitActiveForm}
          onCancel={actions.cancelActiveForm}
        />
      )}
      {!comments.length && !createForm ? (
        <Box display="flex" alignItems="center" justifyContent="center">
          <Typography color="textSecondary">No comments yet</Typography>
        </Box>
      ) : (
        comments.map(comment => (
          <CommentCard key={comment.id} comment={comment} actions={actions} isReadonly={isReadonly} />
        ))
      )}
    </Stack>
  );
};

export default CommentsList;
